import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Dialog, Spinner } from '@economic/taco';

import internalApiClient from '~/app/shared/util/api/internalApiClient';
import { generateContent } from './utils';

const SysPageModal = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { agreementNumber } = location.state || ({} as any);

    const [content, setContent] = useState<JSX.Element | string | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!agreementNumber) onDialogClose();
        getAndSetAgreementInfo();
    }, [agreementNumber]);

    const getAndSetAgreementInfo = async () => {
        setIsLoading(true);
        try {
            const res = await internalApiClient.get(`/smartpay/integration/${agreementNumber}`);

            const content = generateContent(res.data);

            setContent(content);
        } catch (e) {
            if (e.response.status === 404) {
                setContent('Smart Pay integration not enabled for this agreement');
            } else {
                setContent('Something went wrong');
            }
        }
        setIsLoading(false);
    };

    const onDialogClose = () => {
        // remove modal hash
        navigate(location.pathname);
    };

    return (
        <Dialog size="md" onClose={onDialogClose} defaultOpen>
            <Dialog.Content aria-label="sys page smart pay details modal">
                <Dialog.Title>Smart Pay Integration Details - {agreementNumber}</Dialog.Title>
                {isLoading ? (
                    <div className="h-52 w-full flex items-center justify-center ">
                        <Spinner />
                    </div>
                ) : (
                    <div className="my-5">{content}</div>
                )}
                <Dialog.Footer>
                    <Button onClick={onDialogClose}>Close</Button>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
};

export default SysPageModal;
